<template>
  <div class="highlights-layout">
    <div class="highlights-media-column">
      <ceremony-media-player
        ref="mediaPlayer"
        :active-video-url="activeVideoUrl"
        :ceremony-video-loading="ceremonyVideoLoading"
        :ceremony-video-error="ceremonyVideoError"
        :video-options="videoOptions"
        @loadeddata="$emit('loadeddata')"
      />
    </div>

    <aside class="highlights-copy-card">
      <p class="highlights-copy-label">{{ detailLabel }}</p>

      <div class="highlights-stats">
        <div class="highlights-stat">
          <span class="highlights-stat-label">Timestamp</span>
          <span class="highlights-stat-value">{{ timestampLabel }}</span>
        </div>
        <div class="highlights-stat">
          <span class="highlights-stat-label">Duration</span>
          <span class="highlights-stat-value">{{ durationLabel }}</span>
        </div>
      </div>

      <div class="highlights-copy-block">
        <p class="highlights-copy-title">How It Works</p>
        <p class="highlights-copy-text">{{ detailCopy }}</p>
      </div>
    </aside>
  </div>
</template>

<script>
import CeremonyMediaPlayer from './CeremonyMediaPlayer.vue'

export default {
  name: 'CeremonyHighlightsPlayer',
  components: {
    CeremonyMediaPlayer,
  },
  props: {
    activeVideoUrl: {
      type: String,
      default: '',
    },
    ceremonyVideoLoading: {
      type: Boolean,
      default: false,
    },
    ceremonyVideoError: {
      type: String,
      default: '',
    },
    videoOptions: {
      type: Object,
      required: true,
    },
    activeEvent: {
      type: Object,
      default: () => ({}),
    },
    formatDuration: {
      type: Function,
      required: true,
    },
  },
  computed: {
    player() {
      return this.$refs.mediaPlayer?.player || null
    },
    timestampLabel() {
      const seconds = Number(this.activeEvent?.timestamp)
      return Number.isFinite(seconds) ? this.formatDuration(seconds) : '00:00'
    },
    durationLabel() {
      const value = String(this.activeEvent?.duration || '').trim()
      return value || '00:00'
    },
    detailLabel() {
      return this.activeEvent?.type === 'chapter' ? 'Chapter Details' : 'Highlight Details'
    },
    detailCopy() {
      if (this.activeEvent?.type === 'chapter') {
        return 'Chapters are grouped from the ceremony transcript and let you jump directly to each section.'
      }
      return 'Ceremony Intelligence picks out key moments from your ceremony for you to watch and review.'
    },
  },
}
</script>

<style scoped>
.highlights-layout {
  display: grid;
  grid-template-columns: minmax(0, 2.2fr) minmax(280px, 1fr);
  gap: 24px;
  align-items: start;
}

.highlights-media-column {
  min-width: 0;
}

.highlights-copy-card {
  border: 1px solid #d6dbe5;
  border-radius: 0.25rem;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  padding: 22px;
}

.highlights-copy-label {
  margin: 0 0 18px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.highlights-stats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 22px;
}

.highlights-stat-label,
.highlights-stat-value {
  display: block;
}

.highlights-stat-label {
  margin-bottom: 4px;
  font-size: 0.75rem;
  color: #64748b;
}

.highlights-stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.1;
  color: #0f172a;
}

.highlights-copy-block + .highlights-copy-block {
  margin-top: 18px;
}

.highlights-copy-title {
  margin: 0 0 8px;
  font-size: 0.88rem;
  font-weight: 700;
  color: #0f172a;
}

.highlights-copy-text {
  margin: 0;
  font-size: 0.92rem;
  line-height: 1.65;
  color: #475569;
}

@media (max-width: 1023px) {
  .highlights-layout {
    grid-template-columns: 1fr;
  }
}
</style>
